export const environment = {
  production: true,
  proxyUrl: 'https://lea.test.proxy.eveasoft.com',
  date: '', // Permet de voir quelle version est déployée (à remplacer lors du déploiement)
  version: '3.6.5',
};



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/environments/environment.ts